import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import { caseLogicMsg } from '~lib/common/validators/validationMessages';
import { getAllCharacters } from '~lib/common/utils/characters';
import { activeNpcs } from '~lib/common/utils/npc';

export function validateNodeWithCharacters(node, nodeType, controlTypes = [], caseConf, checkKey = null) {
  const errors = [];
  
  const nodeOfTypeKey = checkKey || nodeType;
  const nodeOfType = get(node, 'data.' + nodeOfTypeKey);
  if (!nodeOfType) return;
  if (!controlTypes.includes(nodeOfType.type)) return;

  const characters = getAllCharacters(caseConf);
  const charactersByKey = keyBy(characters, 'key');
  const npcs = activeNpcs(caseConf);
  const npcsByKey = keyBy(npcs, 'key');

  const errorMetadata = {};
  if (checkKey) errorMetadata.checkKey = checkKey;

  if (nodeOfType.sourceCharacterKey && !charactersByKey[nodeOfType.sourceCharacterKey]) {
    errorMetadata.errorId = 'missingSourceCharacter';
    errors.push(caseLogicMsg('Source character could not be found', node.id, errorMetadata));
  }
  if (nodeOfType.targetCharacterKey && !charactersByKey[nodeOfType.targetCharacterKey]) {
    errorMetadata.errorId = 'missingTargetCharacter';
    errors.push(caseLogicMsg('Target character could not be found', node.id, errorMetadata));
  }
  if (nodeOfType.npcKey && !npcsByKey[nodeOfType.npcKey]) {
    errorMetadata.errorId = 'missingSourceCharacter';
    errors.push(caseLogicMsg('VIP could not be found', node.id, errorMetadata));
  }
  return errors;
}